module.exports = __webpack_public_path__ + "static/media/13ITC3.47e663ea.jpg";